import * as aawzDriveStore from './store'

export function aawzDriveModule({ store }) {
  store.registerModule('aawz-drive', {
    ...aawzDriveStore,
    namespaced: true,
  })
}
